module.exports = "pegasus_template/assets/loading-icon.gif";